import { render, staticRenderFns } from "./claimsInfo.vue?vue&type=template&id=2cb7c9e6&scoped=true"
import script from "./claimsInfo.vue?vue&type=script&lang=js"
export * from "./claimsInfo.vue?vue&type=script&lang=js"
import style0 from "./claimsInfo.vue?vue&type=style&index=0&id=2cb7c9e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7c9e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb7c9e6')) {
      api.createRecord('2cb7c9e6', component.options)
    } else {
      api.reload('2cb7c9e6', component.options)
    }
    module.hot.accept("./claimsInfo.vue?vue&type=template&id=2cb7c9e6&scoped=true", function () {
      api.rerender('2cb7c9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/recordManage/recordFrom/claimsInfo.vue"
export default component.exports